module.exports = __webpack_public_path__ + "static/media/ft_memo.acc2eb63.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ft_memo.png
// module id = 1627
// module chunks = 1